module.exports = __webpack_public_path__ + "869057a34107ffa0f7fb16bfa8710197.png";